/**
 * JS to run on every page.
 */
class CTEKBaseTheme extends DrupalBehavior {
  onReady(document) {
    super.onReady();
    if (this.debug) {
      this.enquireDebug();
    }
  }

  onContent(context) {
    this.externalLinks(context);
  }

  externalLinks(context) {
    $(
      `a[href*="//"]:not([href*="${document.location.hostname}"],[href*="doctors.rush.edu"])`,
      context
    )
      .attr('target', '_blank')
      .addClass('external');
  }

  enquireDebug() {
    const breakpoints = this.settings.breakpoints;
    const createHandler = (breakpoint) => {
      return [
        breakpoint.query,
        {
          match: () =>
            console.log(
              'Enquire.js: Matched:',
              breakpoint.theme,
              breakpoint.label
            ),
          unmatch: () =>
            console.log(
              'Enquire.js: Unmatched:',
              breakpoint.theme,
              breakpoint.label
            ),
        },
      ];
    };
    for (var key in breakpoints) {
      if (breakpoints.hasOwnProperty(key)) {
        enquire.register.apply(enquire, createHandler(breakpoints[key]));
      }
    }
  }
}

DrupalBehavior.register('ctek_base_theme', 'global', CTEKBaseTheme);
